import styled, { css, keyframes } from 'styled-components';

const resizeIn = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
`;

const resizeOut = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(0);
  }
`;

export const Wrapper = styled.div`
	display: inline-flex;
	position: absolute;
	right: 0;
	cursor: default;

	${({ onClick }) =>
		onClick &&
		css`
			cursor: pointer;
		`};
`;

export const Icon = styled.i`
	color: ${(props) => props.theme.colors.headerIconColor} !important;
	font-size: 24px;
`;

export const BadgeContent = styled.span`
	position: absolute;
	right: -7px;
	top: -7px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-color: rgba(225, 0, 80, 1);
	color: #fff;
	border-radius: 10px;
	padding: 2px;
	font-size: 0.7rem;
	font-weight: 500;
	min-width: 14px;
	height: 14px;

	${({ setAnimate }) =>
		setAnimate
			? css`
					animation: ${resizeIn} 0.5s ease-in-out;
			  `
			: css`
					animation: ${resizeOut} 0.5s ease-in-out;
					transform: scale(0);
			  `};
`;
